var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "23", viewBox: "0 0 20 23", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Group 9 Copy"
    ),
    React.createElement(
      "g",
      { id: "iOS", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "SMS---Hardwall---Finalish", transform: "translate(-53 -214)", fill: "#1A1A1A", fillRule: "nonzero" },
        React.createElement(
          "g",
          { id: "Group-2", transform: "translate(38 201)" },
          React.createElement(
            "g",
            { id: "Group-3" },
            React.createElement(
              "g",
              { id: "Group-9-Copy", transform: "translate(15 13)" },
              React.createElement("path", { d: "M10 0c2.852 0 5.173 2.18 5.248 4.895l.002.136v1.677h2c1.46 0 2.655 1.091 2.745 2.47l.005.166v11.02C20 21.82 18.769 23 17.25 23H2.75C1.231 23 0 21.82 0 20.365V9.344c0-1.456 1.231-2.636 2.75-2.636h2V5.031C4.75 2.252 7.1 0 10 0zm7.25 8.146H2.75c-.69 0-1.25.536-1.25 1.198v11.02c0 .662.56 1.198 1.25 1.198h14.5c.69 0 1.25-.536 1.25-1.197V9.344c0-.662-.56-1.198-1.25-1.198zM10 12.01c1.453 0 2.636 1.114 2.636 2.495 0 1.134-.796 2.087-1.885 2.393l-.001 1.597c0 .397-.336.718-.75.718a.739.739 0 0 1-.747-.65l-.003-.068v-1.597c-1.089-.305-1.886-1.26-1.886-2.393 0-1.38 1.183-2.495 2.636-2.495zm0 1.437c-.63 0-1.136.477-1.136 1.058 0 .582.506 1.058 1.136 1.058.63 0 1.136-.476 1.136-1.058 0-.582-.506-1.058-1.136-1.058zm0-12.01c-2.03 0-3.684 1.546-3.748 3.477l-.002.116v1.677h7.5V5.031c0-1.985-1.679-3.593-3.75-3.593z", id: "Combined-Shape" })
            )
          )
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/lock.svg